"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var actions = __importStar(require("../signUpActions"));
var signup_module_scss_1 = __importDefault(require("../signup.module.scss"));
//directus
var sdk_1 = require("@directus/sdk");
var directus = new sdk_1.Directus(process.env.REACT_APP_DIRECTUS_BACKEND);
var users = directus.users;
var ActivationKeyStage = /** @class */ (function (_super) {
    __extends(ActivationKeyStage, _super);
    function ActivationKeyStage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activationKey: "",
            password: "",
            confirmPassword: "",
            match: false,
            error: false,
            loading: false
        };
        /*
        componentDidUpdate(prevState) {
          const { value } = this.state;
          if (value != prevState.value) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
            'event':'signup-activation-step',
            'event_category':'engagement',
            'event_action':'signup-activation-step'
            });
          }
        } */
        _this.onSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, password, confirmPassword, activationKey, history;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state, password = _a.password, confirmPassword = _a.confirmPassword, activationKey = _a.activationKey;
                        history = this.props.history;
                        this.setState({ loading: true });
                        if (!(password === confirmPassword)) return [3 /*break*/, 2];
                        //passwords match
                        this.setState({ match: true });
                        return [4 /*yield*/, users.invites.accept(activationKey, password).then(function (res) {
                                console.log(res);
                                history.push("/signup/success");
                            }).catch(function (err) {
                                console.log(err);
                                _this.setState({ error: "There was an error with activation" });
                                _this.setState({ loading: false });
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ActivationKeyStage.prototype.componentDidMount = function () {
        var queryParameters = new URLSearchParams(window.location.search);
        var token = queryParameters.get("token");
        if (token) {
            this.setState({ activationKey: token });
        }
    };
    ActivationKeyStage.prototype.render = function () {
        var _this = this;
        var activationKey = this.state.activationKey;
        var queryParameters = new URLSearchParams(window.location.search);
        var token = queryParameters.get("token");
        return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, __assign({ className: signup_module_scss_1.default.column, computer: 10, mobile: 16, tablet: 9, style: { margin: "auto" } }, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, __assign({ className: signup_module_scss_1.default.grid }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: signup_module_scss_1.default.header }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: signup_module_scss_1.default.title }, { children: "Activate Your Account" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: signup_module_scss_1.default.sub }, { children: "Check your email for your activation key then fill in the form below." })), (0, jsx_runtime_1.jsx)("p", { children: this.state.error && (0, jsx_runtime_1.jsx)("p", __assign({ style: { color: "red" } }, { children: this.state.error })) })] })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Divider, {}), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form, __assign({ onSubmit: this.onSubmit, className: signup_module_scss_1.default.form }, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, __assign({ required: true }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "activation_key_input" }, { children: "Activation Key" })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Input, { id: "activation_key_input", value: activationKey, onChange: function (e, _a) {
                                                    var value = _a.value;
                                                    return _this.setState({ activationKey: value });
                                                }, type: "text", disabled: token, spellcheck: "false" })] })), (0, jsx_runtime_1.jsx)("p", { children: this.state.password !== "" ? this.state.password === this.state.confirmPassword ? (0, jsx_runtime_1.jsx)("p", __assign({ style: { color: "#2CA9F9" } }, { children: "Passwords match" })) : (0, jsx_runtime_1.jsx)("p", __assign({ style: { color: "red" } }, { children: "Passwords do not match" })) : "" }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, __assign({ required: true }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "password" }, { children: "Password" })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Input, { id: "password", onChange: function (e, _a) {
                                                    var value = _a.value;
                                                    return _this.setState({ password: value });
                                                }, type: "password", spellcheck: "false" })] })), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, __assign({ required: true }, { children: [(0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "password" }, { children: "Confirm Password" })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Form.Input, { id: "confirmPassword", onChange: function (e, _a) {
                                                    var value = _a.value;
                                                    return _this.setState({ confirmPassword: value });
                                                }, type: "password", spellcheck: "false" })] })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Divider, {}), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, __assign({ onClick: function () {
                                            return window.dataLayer.push({
                                                event: "signup-activate-btn",
                                                event_category: "engagement",
                                                event_action: "signup-activate-btn",
                                            });
                                        }, type: "submit", disabled: !this.state.activationKey || !this.state.password || !this.state.confirmPassword || (this.state.password !== this.state.confirmPassword), className: signup_module_scss_1.default.proceed, loading: this.state.loading }, { children: "Activate" }))] }))] })) })) }) }));
    };
    return ActivationKeyStage;
}(react_1.PureComponent));
exports.default = (0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(function (state) {
    return {
        signUpStatus: state.signUp.signUpStatus,
    };
}, function (dispatch) { return ({
    activateUser: function (params) {
        dispatch(actions.activateUser(params));
    },
}); })(ActivationKeyStage));
